<lex-doc-viewer-dialog>
    <div dialog-title>{{title}}</div>
    <div dialog-body style="overflow: auto; max-height: 350px;">
        <div class="connections-list">
            <div *ngFor="let item of items" class="connection-item">
              <div class="connection-text">{{item}}</div>
            </div> 
        </div>
    </div>
</lex-doc-viewer-dialog>